// extracted by mini-css-extract-plugin
export default {"newColumn":"NewColumn_newColumn__+2r2z","newColumnIcon":"NewColumn_newColumnIcon__TEkWl","newColumnTitle":"NewColumn_newColumnTitle__cqfT+"};